import { IP } from 'src/dtos/version.dto';
import { ActionType } from './enums';
import { convertDirectionToBackend } from './direction-utils';

export function buildCreateIpRequestBody(record: IP): any {
    return {
        description: record.description,
        addressKeyDto: {
            direction: convertDirectionToBackend(record.direction),
            type: record.type,
            value: record.value,
        }
    };
}

export function buildDeleteIpRequestBody(record: IP): any {
    return {
        objectDisplayName: record.displayName,
        direction: convertDirectionToBackend(record.direction)
    };
}

export function buildUpdateIpRequestBody(updatedRecord: IP, originalData: IP): any {
    return {
        description: updatedRecord.description,
        addressKeyDto: {
            direction: convertDirectionToBackend(originalData.direction),
            type: originalData.type,
            value: originalData.value,
        },
        updatedAddressKeyDto: {
            direction: convertDirectionToBackend(updatedRecord.direction),
            type: updatedRecord.type,
            value: updatedRecord.value,
        },
        // for actionType changes - tell the backend which target actionType to create
        ...(updatedRecord.actionType !== originalData.actionType && {
            newActionRule: updatedRecord.actionType === ActionType.ALLOW ? 'ALLOW' : 'DROP'
        })
    };
}